import { Link } from "react-router-dom";
import { FaCheckCircle, FaBriefcase, FaMapMarkerAlt, FaDollarSign, FaArrowRight } from "react-icons/fa";
import PageHeader from "../components/layout/PageHeader";
import SectionTitle from "../components/common/SectionTitle";
import { careers, careerBenefits } from "../data/blog";

export default function Careers() {
  return (
    <>
      <PageHeader title="Careers" crumbs={[{ label: "Careers" }]} />

      <section className="section">
        <div className="container">
          <SectionTitle
            subtitle="Join Our Team"
            title="Become a Part of Our <span>Taxi Driving Team</span>"
            text="Build a rewarding career with a company that values its people."
          />
          <div className="grid grid-3" style={{ marginBottom: 20 }}>
            {careerBenefits.map((b, i) => (
              <div className="card" style={{ padding: 26, display: "flex", gap: 12 }} key={i}>
                <FaCheckCircle style={{ color: "var(--yellow)", marginTop: 4, flexShrink: 0 }} />
                <p style={{ color: "var(--gray-light)", fontSize: 14.5 }}>{b}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section bg-dark2">
        <div className="container">
          <SectionTitle subtitle="Open Positions" title="Current <span>Job Openings</span>" />
          {careers.map((job) => (
            <div className="job-card" key={job.id}>
              <div className="job-head">
                <h3>{job.title}</h3>
                <span className="chip">{job.positions}</span>
              </div>
              <p className="sec-text" style={{ margin: "12px 0" }}>{job.desc}</p>
              <div className="job-tags">
                <span><FaBriefcase /> {job.type}</span>
                <span><FaMapMarkerAlt /> {job.location}</span>
                <span><FaDollarSign /> {job.salary}</span>
              </div>
              <Link to={`/careers/${job.id}`} className="btn btn-primary">
                View Details <FaArrowRight />
              </Link>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
